// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"remarks_wrapper__3ANcb","header":"remarks_header__ePCfm","label":"remarks_label__20V4b","content":"remarks_content__1AxpH","warn":"remarks_warn__1krKk"};